import { http } from 'src/config';
import { URLSVC } from 'src/config/helper/urlService';
import Swal from 'sweetalert2'
import { loadingBar } from '../globalAction';

export const setKritikSarans = () => {
    return (dispatch) => {
        http.get(`${URLSVC}/app/user/GetUserSuggestions`).then((res) => {
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({type: 'DATA_KRITIKSARANS', payload: data.Data})
            } else {
                dispatch({type: 'DATA_KRITIKSARANS', payload: data.Data})
                //Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setKritikSaran = (Id) => {
    return (dispatch) => {
        loadingBar(true);
        dispatch({type: 'RESET_FORM_KRITIKSARAN'})
        var Url = `${URLSVC}/app/user/GetUserSuggestion?Id=${Id}`;
        http.get(Url).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({ type: 'DATA_KRITIKSARAN', payload: data.Data })

                dispatch(setFormKritikSaran('Id', data.Data.Id))
                dispatch(setFormKritikSaran('Name', data.Data.Name))
                dispatch(setFormKritikSaran('Email', data.Data.Email))
                dispatch(setFormKritikSaran('Mobile', data.Data.Mobile))
                dispatch(setFormKritikSaran('DatasetSuggestion', data.Data.DatasetSuggestion))
                dispatch(setFormKritikSaran('DatasetReason', data.Data.DatasetReason))
                dispatch(setFormKritikSaran('UserSuggestionCategory', data.Data.UserSuggestionCategory))
                dispatch(setFormKritikSaran('DatasetCategory', data.Data.DatasetCategory))
                dispatch(setFormKritikSaran('Status', data.Data.Status))

                dispatch({type: 'MODAL_KRITIKSARAN', payload: true})
                
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setFormKritikSaran = (formType, formValue) => {
    return {type: 'FORM_KRITIKSARAN', formType, formValue}
}

export const apiApproveKritikSaran = (iData) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan menyetujui data kritik & saran dari (${iData.Name})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', iData.Id);
                fd.append('Note', iData.Note);
                http.post(`${URLSVC}/app/user/UserSuggestionApprove`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil menyetujui data (${iData.Name})`, 'success')
                        dispatch(setKritikSarans())
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}
